import {VuexObjectMixin} from '../../../Mixins';
import Component from 'vue-class-component';
import {OrderItem} from '../../../Models';
import Modal from '../../Modal/Modal.vue';
import PersonalUseItem from '../PersonalUseItem/PersonalUseItem.vue';
import {UPDATE_CART, UPDATE_ORDER_ITEM, UPDATE_ORDER_ITEM_CONFIGURATION} from '../../../store/commits';
import {CartDTO, OrderDTO} from '../../../DTOs';
import {OrderService, ProductService} from '../../../Services';
import {Prop, Watch} from 'vue-property-decorator';
import {OrderCheckoutStepEnum} from '../../../Enums';
import {AdditionalOrderItemConfiguration} from '../../../Models/AdditionalOrderItemConfiguration';

@Component({
  components: {
    Modal,
    PersonalUseItem,
  },
})
export default class PersonalUseModal extends VuexObjectMixin {
  @Prop({type: String, required: true}) modalTriggerText: string | undefined;
  @Prop({type: String, required: true}) inventoryUrl: string | undefined;
  @Prop({type: String, required: true}) checkoutUrl: string | undefined;
  @Prop({type: String, required: true}) ticketShopUrl: string | undefined;
  @Prop({type: Function, required: false}) submitCb: any;
  @Prop({type: Boolean, required: false, default: true}) isModalTriggerCTA: boolean | undefined;
  @Prop({type: Boolean, required: false, default: false}) initialOpen: boolean | undefined;

  private availableItemsForPersonalUse: Array<AdditionalOrderItemConfiguration> = [];
  private submitting: boolean = false;

  async mounted() {
    this.fillAvailableItemsForPersonalUse();
  }

  async updatePersonalUSe(orderItemConfig: AdditionalOrderItemConfiguration, value: Boolean) {
    this.$store.commit(UPDATE_ORDER_ITEM_CONFIGURATION, {orderItemConfig, data: {personalUse: value}});
  }

  @Watch('cart')
  onCartChange() {
    this.fillAvailableItemsForPersonalUse();
  }

  showModal() {
    if (this.$refs.personalUseSelectionModal) {
      // @ts-ignore
      this.$refs.personalUseSelectionModal.showModal();
    }
  }

  closeModal() {
    if (this.$refs.personalUseSelectionModal) {
      // @ts-ignore
      this.$refs.personalUseSelectionModal.closeModal();
    }
  }

  async onSubmit() {
    try {
      this.submitting = true;
      const orderDTO = (new OrderDTO()).fromModel(this.currentOrder!);
      const cart = await this.orderService.updateCart(orderDTO, this.userLanguage);
      this.$store.commit(UPDATE_CART, cart);

      this.submitCb ? this.submitCb() : this.toCheckoutForm();
    } finally {
      this.submitting = false;
    }

    if (this.$refs.personalUseSelectionModal) {
      // @ts-ignore
      this.$refs.personalUseSelectionModal.closeModal();
    }
  }

  toCheckoutForm() {
    if (this.checkoutUrl) {
      const searchParams = new URLSearchParams(window.location.search);
      let step = OrderCheckoutStepEnum.PERSONALIZATION;

      if (!this.hasSelectedForPersonalUse) {
        if (this.anyProductHasPubTransIncluded) {
          step = OrderCheckoutStepEnum.PUBLIC_TRANSPORT;
        } else {
          step = OrderCheckoutStepEnum.PAYMENT;
        }
      }

      searchParams.set('step', step.toString());
      window.location.href = `${this.checkoutUrl}?${searchParams.toString()}`;
    }
  }

  toTicketShop() {
    if (this.ticketShopUrl) {
      window.location.href = this.ticketShopUrl;
    }
  }

  get hasOrderItems(): boolean {
    if (!this.cart) {
      return false;
    }
    return this.cart.order.orderItems.length > 0;
  }

  get anyProductHasPubTransIncluded() {
    return this.products.filter(p => p.localPubTransIncluded === 1).length > 0;
  }

  get hasSelectedForPersonalUse(): boolean {
    let areItemsSelected: boolean = false;
    if (this.cart) {
      this.cart.order.additionalOrderItemConfigurations.forEach((orderItemConfig) => {
        if (areItemsSelected) {
          return;
        }
        if (orderItemConfig.personalUse) {
          areItemsSelected = true;
          return;
        }
      });
    }
    return areItemsSelected;
  }

  get hasChosenForAllTickets(): boolean {
    let nonChosenAoics: Array<AdditionalOrderItemConfiguration> = [];
    if (this.cart && this.cart.order) {
      this.cart.order.additionalOrderItemConfigurations.forEach((aoic) => {
        if (aoic.personalUse === null) {
          nonChosenAoics.push(aoic);
        }
      });
    }
    return nonChosenAoics.length === 0;
  }

  get triggerClassList(): string {
    let classList = 'button';
    if (this.isModalTriggerCTA) {
      classList += ' button-inverted';
    }
    return classList;
  }

  fillAvailableItemsForPersonalUse(): void {
    this.availableItemsForPersonalUse = [];
    let additionalOrderItemConfigs: Array<AdditionalOrderItemConfiguration> = [];
    if (this.cart && this.cart.order && this.products) {
      this.cart.order.additionalOrderItemConfigurations.forEach((aoic) => {
        if (this.cart instanceof CartDTO) {
          // aoic.product = aoic.getProduct(this.cart.order, this.products);
          aoic.orderItem = aoic.getOrderItem(this.cart.order);
          // TODO: Let backend accept 'null' as value here and check it there accordingly, then remove this condition
          if (!aoic.getProduct()?.isRegistrationRequired) {
            aoic.personalUse = false;
          }
        }
        additionalOrderItemConfigs.push(aoic);
      });
    }
    this.availableItemsForPersonalUse = additionalOrderItemConfigs;
  }
}
